import { createContext } from 'react';

function createFragmentContext<T>() {
    return createContext<T>({} as T);
}

export const fragmentContext = createFragmentContext();
